module.exports = __webpack_public_path__ + "static/media/share-post.7fd06c33.svg";